import { createFileRoute } from "@tanstack/react-router";
import ReminderBrowsePage from "@/site/pages/reminder-browse";
import { validateBrowseSearch } from "@/site/pages/reminder-browse-schema";

/**
 * Legacy URL parity — `/holiday/browse` (PRD 13, 2026-09-15, Nick).
 *
 * This is the holiday sibling of `/birthday/browse`
 * (3,185 page views in 90 days) because it is the CTA of every holiday-reminder
 * email, and those emails keep arriving from inboxes long after cutover. Legacy served
 * one shared page at `/:reminderType/browse` with three server-whitelisted types
 * (`bday/web.py:1346,1350,1354`); we mirror that as three explicit routes rather than a
 * `$type` param so an unknown occasion 404s here exactly as it did there.
 *
 * The occasion is presentational + an analytics dimension: the page resolves the real
 * landing category from `?reminder_id=` via `/user/reminders/:id/browse-context`.
 */
export const Route = createFileRoute("/holiday/browse")({
  component: () => <ReminderBrowsePage occasion="holiday" />,
  validateSearch: validateBrowseSearch,
});
